import { APP_SWITCH_ANALYTICS_EVENTS } from './app-switch-analytics';

export const SHARED_ANALYTICS_EVENTS = {
  ...APP_SWITCH_ANALYTICS_EVENTS,
  openDashboards: '_open_dashboards',
  openWalls: '_open_walls',
  openReports: '_open_reports',
  openUserProfile: '_open_user_profile',
  openOrganization: '_open_organization',
} as const;

export type SharedAnalyticsEvent =
  (typeof SHARED_ANALYTICS_EVENTS)[keyof typeof SHARED_ANALYTICS_EVENTS];
